import { render, staticRenderFns } from "./BookType.vue?vue&type=template&id=c2ebb8aa"
import script from "./BookType.vue?vue&type=script&lang=js"
export * from "./BookType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports